import React from 'react';

import { ActionButtonType } from './types';
import styles from './section-card.module.scss';


interface IActionButtonsProps {
  actions: ActionButtonType[];
}

export default function ActionButtons({ actions }: IActionButtonsProps) {
  return (
    <div className={styles['ag-section-details__actions']} data-testid="action-btn">
      {actions && actions?.length ? (
        actions.map((action: ActionButtonType, index: number) => (
          <button
            key={index}
            type="button"
            disabled={action.disabled}
            onClick={action.callback}
          >
            {action.buttonText}
          </button>
        ))
      ) : null}
    </div>
  );
}
